import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { BodyMedium, LabelSmall } from "Cobalt/BodyText";
import InfoPopover from "Common/InfoPopover";
import { getBreakpoint } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const bem = makeBem("SIFormLabel");
type Props = {
  className?: string;
  label: string;
  inlineLabel?: boolean;
  status: "error" | "warning" | "valid" | "untouched";
  hint?: React.ReactNode;
  guidance?: React.ReactNode;
  triggerText?: string;
  placement?: string;
} & React.ElementProps<"label">;

const SIFormLabel = ({ className, label, inlineLabel, status, hint, guidance, triggerText, ...rest }: Props) => {
  const statusClass = status;
  const classes = classnames(bem("Body"), className, bem("Body", statusClass));
  return (
    <div className={classnames(bem(), "flex flex-row gap-1", { "justify-between": !inlineLabel })}>
      <BodyMedium componentClass="label" mb={3} className={classes} {...rest}>
        {label || "\u00a0"}
        {hint && (
          <LabelSmall className={bem("Hint")} componentClass="span" disabled>
            {hint}
          </LabelSmall>
        )}
      </BodyMedium>

      {guidance && (
        <InfoPopover
          infoText={guidance}
          triggerText={triggerText}
          className="SIFormLabel__Guidance cursor-pointer"
          {...(getBreakpoint() === "xs"
            ? {
                placement: "top",
              }
            : {})}
          {...rest}
        />
      )}
    </div>
  );
};

SIFormLabel.propTypes = {
  hint: PropTypes.string,
};
export default SIFormLabel;
